import { Fragment } from 'react';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

import { useLetter } from '../LetterContext';
import { getLivePreviewPhaseChips } from '../lib/helpers';

const LetterPhaseChips = () => {
  const { config, activePhaseField } = useLetter();
  const phase = config?.phases?.find((p) => p.field === activePhaseField);
  const chips = getLivePreviewPhaseChips(phase, config?.payment_methods);

  if (!chips.length) return null;

  return (
    <div className="flex h-10 items-center gap-1.5 border-0 border-b border-solid border-b-neutral-200 bg-white px-4 py-2">
      {chips.map((chip, index) => (
        <Fragment key={chip}>
          {index > 0 && <Dot size="xs" color="neutral" />}
          <Typography
            variant="p"
            size="xs"
            weight="medium"
            color="neutral-700"
            className="shrink-0">
            {chip}
          </Typography>
        </Fragment>
      ))}
    </div>
  );
};

export default LetterPhaseChips;
